import { render, staticRenderFns } from "./BookingsIcon.vue?vue&type=template&id=4fb36af4"
import script from "./BookingsIcon.vue?vue&type=script&lang=ts"
export * from "./BookingsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports